import React, { Component, lazy } from "react";
import { navigate } from "gatsby";

// TODO - translations must work differently someday...
import provisionalModuleDataBasedOnLanguage from "./gausta/provisionalModuleData";

import pages from "src/../src-dynamic/destination.pages";
import Suspense from "src/components/suspense";
import { getQuery } from "src/utils/query";
import { addListener, removeListener } from "src/utils/events";

// Lazy components splitting:
const LoginModal = lazy(() => import(/* webpackChunkName: "login-modal-component" */ "src/components/loginModal"));

/**
 * Login Modal Watcher V2
 * - used in src/layouts/layout-root.
 */
export default class LoginModalWatcherV2 extends Component {
  
  state = {
    displayLoginModal: false,
    redirected: false
  }

  componentDidUpdate() {
    if (getQuery().redirected && !this.state.redirected) { this.setState({ displayLoginModal: true, redirected: true }); }
  }

  componentDidMount() {
    if (getQuery().redirected && !this.state.redirected) { this.setState({ displayLoginModal: true, redirected: true }); }
    addListener('login-modal', this.onLoginModalEvent);
  }

  componentWillUnmount() {
    removeListener('login-modal', this.onLoginModalEvent);
  }

  getAccountSlug = () => {
    const { language } = this.props;
    const accountpage = pages.account_page
      ? (pages.account_page).find(translation => translation.language === language)
      : null;

    return accountpage?.slug || "/account";
  }

  onLoginModalEvent = (ev) => {
    if (process.env.GATSBY_INNTOPIA_SALES) {
      navigate(this.getAccountSlug());
      return;
    }

    this.setState({displayLoginModal: true});
  }

  renderLoginModal() {
    const { displayLoginModal } = this.state;
    if (!displayLoginModal) return null;
    const accountSlug = this.getAccountSlug();

    return (
        <LoginModal
          show={displayLoginModal}
          closeFn={() => this.setState({ displayLoginModal: false })}
          onFinishLogin={() => navigate(accountSlug)}
          moduleData={provisionalModuleDataBasedOnLanguage(this.props.language)}
        />
    )
  }
  
  render() {
    return <Suspense fallback={null}>
        {this.renderLoginModal()}
    </Suspense>
  }
}